import Cookies from 'js-cookie';
import { isAppUser } from '../../Utils/commonUtils';
import queryString from 'query-string';
import {
  androidIsAppUser,
  isAndroidOpenDeeplink,
  getAndroidAppPageInstance,
} from '../../Utils/androidUtils';
import { createRestApiClient } from '../../datafetchers';
import { checkCreateNuxUrl } from '../../datafetchers/OrderSuccessPage';
import { getUserToken } from '../../Utils/helper';
import { fireEvent } from '../../Utils/fireEvent';

export const fetchNuxId = async (
  id,
  deeplink = '',
  deeplinkValue = '',
  orderIncludesSMC = false,
) => {
  const restApiClient = createRestApiClient();

  const myUserData = Cookies.get('react_user_properties')
    ? JSON.parse(Cookies.get('react_user_properties'))
    : '';

  const body = {
    nux_id: `NUX_WEB_TO_APP_${id}`,
    stages: ['mother', 'pregnant', 'ttc'],
    visible_time: 0,
    screens: {},
    tab_badge: {},
    nuxScreens: [],
    position: 'TOP',
    deeplinkData: {
      deeplink_path: orderIncludesSMC ? '' : '501',
      show_policy_terms_screen: 'false',
      mandate_phone_login: 'true',
      post_login_deeplink: deeplink || 61,
      deeplink_value: myUserData?.user_id,
      post_login_deeplink_value: deeplinkValue,
      nux_value: { offerId: '7726' },
      prefilled_phone: myUserData?.mobile,
    },
  };

  try {
    const tooltipData = await checkCreateNuxUrl(`NUX_WEB_TO_APP_${id}`);

    if (!tooltipData?.data) {
      await restApiClient.request({
        method: 'POST',
        url: `new/nuxTooltip/createNuxTooltip`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Bearer ${getUserToken(true)}`,
        },
      });
    }

    const utmParam = deeplink == 61 ? 'track_order' : 'install_offer_banner';
    const link = `https://app.mylofamily.com/NUX_WEB_TO_APP_${id}?utm_source=appToWeb&utm_medium=Web&utm_campaign_name=app_install_banner&listing=shopfirst&nux_first=true`;

    window.location.href = link;
  } catch (error) {
    console.error('Error in fetchNuxId:', error);
  }
};

export const getBrandName = (brand) => {
  return brand == 'MYLO BABY' ? 'myloBabyCategory' : 'myloCareCategory';
};

export const getbaseRoute = (homeRoute = '') => {
  /** @param {*} homeRoute:{string} this parameter will come only if you want to navigate to home */
  if (isAppUser()) {
    return `/gullack/v2/${homeRoute}`;
  } else {
    return '/store/';
  }
};

export const getScreenName = () => {
  const path = window.location.pathname;
  switch (true) {
    case path === '/store' || path === '/gullack/v2/home':
      return 'Store';
    case path === '/gullack/v2/cart' || path === '/store/cart':
      return 'Cart';
    case path === '/gullack/v2/cart/changeaddress' ||
      path === '/store/cart/changeaddress':
      return 'Change Address';
    case path.includes('/gullack/v2/address/') ||
      path.includes('/store/address/'):
      return 'Add Address';
    case path.includes('/gullack/v2/placeorder') ||
      path.includes('/store/placeorder'):
      return 'Order Summary';
    case path.includes('/gullack/v2/checkout') ||
      path.includes('/store/checkout'):
      return 'Payment';
    case path.includes('/gullack/v2/ordersuccess/') ||
      path.includes('/store/ordersuccess/') ||
      path.includes('/store/order/'):
      return 'order_success';
    case path.includes('/gullack/v2/discussions/') ||
      path.includes('/store/discussions/'):
      return 'Discussion Page';
    case path.includes('/gullack/v2/orderinfo/') ||
      path.includes('/store/orderinfo/'):
      return 'order_detail_page';
    case path.includes('/gullack/v2/reviews/') ||
      path.includes('/store/reviews/'):
      return 'Reviews Page';
    default:
      return 'Other';
  }
};

export function addParamsOnRedirection() {
  const searchParams = new URLSearchParams(window?.location?.search);
  let params = window?.location?.search;
  if (params !== '') {
    if (searchParams) {
      params = params + queryString.stringify(searchParams);
    }
  } else {
    params = '?' + queryString.stringify(searchParams);
  }
  return params;
}

export function resolveGullackURL(url) {
  let newUrl = url;
  if (url?.includes('/gullack/gullack/')) {
    newUrl = newUrl.replace('/gullack/gullack/', '/gullack/');
  }
  return newUrl;
}

export function forceNavigateToReactPage(navigationUrl, data = {}) {
  // check if android app user and is opening Web app from Bottom sheet
  if (
    androidIsAppUser() &&
    getAndroidAppPageInstance() == 'VideoRoundedBottomFragment'
  ) {
    let navUrl = navigationUrl;
    // replaceQueryParamInUrl(
    //   navigationUrl,
    //   "medium",
    //   "pdp_video_section"
    // );
    // Then redirect user to Android General Web Activity to see respective web page
    isAndroidOpenDeeplink('61', resolveGullackURL(URL + navUrl));
  } else {
    window.location = navigationUrl;
  }
}
export function errorInstrumentationHandler() {
  const fireApiHandler = (req, error, payload) => {
    fireEvent({
      category: 'api_error',
      payload: payload ? JSON.stringify(payload).slice(0, 99) : null,
      req: req?.slice(0, 99),
      error: error?.toString().slice(0, 99),
      path_name: window.location.pathname?.toString().slice(0, 99),
    });
  };
  return { fireApiHandler };
}

export function errorInstrumentationHandler1(req, error) {
  fireEvent({
    category: 'error_api',
    req: req?.slice(0, 99),
    error: error?.toString().slice(0, 99),
  });
}

export function UserTypeCheck(userCheck = false) {
  let userType = true;
  userType = isAppUser() ? userType : !isAppUser();

  return userCheck ? userType : true;
}

export const clickedSectionEvent = (fireEvent, value, section) => {
  fireEvent({
    category: 'clicked_card_in_myloshop',
    screen_name: 'order_success',
    section_id: value.itemId,
    card_id: value._id,
    section_name: section.heading,
    card_name: value.name || value.itemName,
    shape: value.itemType,
    deeplink: value.deeplink,
    deeplink_value: value.deeplinkValue,
  });
};

const cashKaroData = (orderData) => {
  let productname = '';
  orderData?.data?.map((element, index) => {
    if (index === 0) {
      productname = element?.nickname;
      return;
    }
    productname = productname + ' | ' + element?.nickname;
  });
  productname.replace('&', 'and');
  const nameSplit = productname.split('&');
  const newName = nameSplit.join('and');
  const apiData = {
    orderValue: orderData?.price_detail?.final_price,
    orderId: orderData?.data?.[0]?.parent_order_id,
    products: newName,
  };
  return apiData;
};

export const cashkaroApiCallback = (orderData) => {
  const params = cashKaroData(orderData);
  const details = Cookies.get('cashkaroDetails');
  const coupon = Cookies.get('coupon_code') || '';
  const parsedDetails = details ? JSON.parse(details) : null;
  if (parsedDetails) {
    const url = `https://offers-cashkaro.affise.com/postback?clickid=${parsedDetails?.clickId}&secure=23bed347d5037ba84c9688a18adbb8f1&action_id=${params?.orderId}&sum=${params?.orderValue}&status=2&custom_field1=${params?.orderValue}&custom_field2=${parsedDetails?.subClickId}&custom_field3=${params?.products}&custom_field5=${coupon}`;
    fetch(url, {
      method: 'GET',
    });
  }
};
